import React from 'react';

import { IFooter20Fields } from '../../../../../types/contentful';

import { Layout } from '../../../Layout';
import { Text } from '../../../Text';
import { NavList } from './NavList';

import { NavListColumn } from './styles';

export function Navigation({ footerLinks }: IFooter20Fields) {
  return (
    <Layout data-testid="footer-nav-links">
      {(footerLinks || []).map(({ fields: { name, links } }: any) => (
        <NavListColumn
          id="nav-list-column"
          key={name}
          size={{ 0: 12, desktop: 3 }}
        >
          <Text
            as="h3"
            fontWeight="500"
            fontSize={{ 0: 'ml', tablet: 'l', desktop: 'xl' }}
            colour="white"
            marginBottom="m"
          >
            {name}
          </Text>
          <NavList links={links} />
        </NavListColumn>
      ))}
    </Layout>
  );
}
